import type { SiteLocale } from './locale'

export const chromeCopy: Record<
  SiteLocale,
  {
    services: string
    process: string
    about: string
    contact: string
    book: string
    homeAria: string
    openMenu: string
    closeMenu: string
    language: string
    footerBlurb: string
    navigation: string
    team: string
    resources: string
    automations: string
    morocco: string
    doctorsAgent: string
    caseStudy: string
    darijaDemo: string
    selectedWork: string
    dentalLanding: string
    leadEnrichment: string
    lawFirmSite: string
    translationPlatform: string
    privacy: string
    terms: string
    reserved: string
  }
> = {
  en: {
    services: 'Services',
    process: 'Process',
    about: 'About',
    contact: 'Contact',
    book: 'Book a call',
    homeAria: 'Forteuno Web home',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
    language: 'Language',
    footerBlurb: 'Custom AI systems that automate back-office tasks and scale your business.',
    navigation: 'Navigation',
    team: 'Team',
    resources: 'Resources',
    automations: 'Automations',
    morocco: 'Morocco solutions',
    doctorsAgent: 'AI agent for doctors',
    caseStudy: 'Case study: dental clinic in Casablanca',
    darijaDemo: 'Darija WhatsApp AI agent demo',
    selectedWork: 'Selected work',
    dentalLanding: 'Dental landing page',
    leadEnrichment: 'AI lead enrichment',
    lawFirmSite: 'Law firm website',
    translationPlatform: 'Translation ordering platform',
    privacy: 'Privacy policy',
    terms: 'Terms of service',
    reserved: 'All rights reserved.',
  },
  fr: {
    services: 'Services',
    process: 'Méthode',
    about: 'À propos',
    contact: 'Contact',
    book: 'Réserver un appel',
    homeAria: 'Accueil Forteuno Web',
    openMenu: 'Ouvrir le menu',
    closeMenu: 'Fermer le menu',
    language: 'Langue',
    footerBlurb: 'Des systèmes d’IA sur mesure qui automatisent le back-office et font grandir votre activité.',
    navigation: 'Navigation',
    team: 'Équipe',
    resources: 'Ressources',
    automations: 'Automatisations',
    morocco: 'Solutions Maroc',
    doctorsAgent: 'Agent IA pour médecins',
    caseStudy: 'Étude de cas : clinique dentaire à Casablanca',
    darijaDemo: 'Démo agent IA WhatsApp en darija',
    selectedWork: 'Travaux sélectionnés',
    dentalLanding: 'Landing page dentaire',
    leadEnrichment: 'Enrichissement de leads IA',
    lawFirmSite: 'Site de cabinet d’avocats',
    translationPlatform: 'Plateforme de commandes de traduction',
    privacy: 'Politique de confidentialité',
    terms: 'Conditions d’utilisation',
    reserved: 'Tous droits réservés.',
  },
  ar: {
    services: 'الخدمات',
    process: 'المنهج',
    about: 'من نحن',
    contact: 'اتصل بنا',
    book: 'احجز مكالمة',
    homeAria: 'الصفحة الرئيسية لـ Forteuno Web',
    openMenu: 'فتح القائمة',
    closeMenu: 'إغلاق القائمة',
    language: 'اللغة',
    footerBlurb: 'أنظمة ذكاء اصطناعي مخصصة لأتمتة الأعمال الخلفية وتوسيع نشاطك.',
    navigation: 'التنقل',
    team: 'الفريق',
    resources: 'الموارد',
    automations: 'الأتمتة',
    morocco: 'حلول المغرب',
    doctorsAgent: 'وكيل ذكاء اصطناعي للأطباء',
    caseStudy: 'دراسة حالة: عيادة أسنان في الدار البيضاء',
    darijaDemo: 'عرض وكيل واتساب بالدارجة',
    selectedWork: 'أعمال مختارة',
    dentalLanding: 'صفحة هبوط لعيادة أسنان',
    leadEnrichment: 'إثراء العملاء المحتملين',
    lawFirmSite: 'موقع مكتب محاماة',
    translationPlatform: 'منصة طلبات ترجمة',
    privacy: 'سياسة الخصوصية',
    terms: 'شروط الاستخدام',
    reserved: 'جميع الحقوق محفوظة.',
  },
}
